import {
  Button,
  Checkbox,
  Text,
  FormControl,
  FormLabel,
  Center,
  Input,
  Box,
  Stack,
  InputGroup,
  InputRightElement,
  useToast,
  Flex,
  Image,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { BsArrowRightShort } from "react-icons/bs";
import AuthContext from "../Utils/auth";
import { loginAPI } from "../Utils/api";
import {
  break_logo,
  break_logo_dark,
  break_logo_light,
  fj_logo,
} from "../theme";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const authCtx = useContext(AuthContext);
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const handleClick = () => setShow(!show);
  const navigate = useNavigate();

  const handleChange = (event, setStateFunction) => {
    const { type, checked, value } = event.target;
    setStateFunction(type === "checkbox" ? checked : value);
  };

  const getLogin = async () => {
    setLoading(true);
    try {
      const loginRes = await loginAPI(email, password);
      if (loginRes.status !== "success") {
        throw new Error(loginRes.data);
      }
      authCtx.login(
        loginRes.data.token,
        loginRes.data.email,
        loginRes.data.name
      );
      window.location = "/";
    } catch (error) {
      console.error(error);
      toast({
        title: "Login failed.",
        description: "wrong Credentials",
        status: "error",
        position: "top-right",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      py={["4", "6"]}
      px={["4", "6"]}
      minH="100vh"
      flexDir="column"
    >
      <Box position="relative">
        <Flex
          style={{ borderWidth: "1px", borderRadius: "10px" }}
          border="1px solid black"
          flexDir="column"
          p={["4", "5"]}
          gap="4"
          w={["100%", "100%", "100%", "xl"]}
        >
          <Center>
            <Image
              src={fj_logo}
              width="auto"
              height={["8vh", "10vh", "12vh"]}
              objectFit="contain"
            />
          </Center>
          <Box>
            <Text fontSize={["20px", "22px", "24px"]} fontWeight={700}>
              Log In
            </Text>
            <Text fontSize={["12px", "13px", "14px"]} color={"#717171"}>
              Let's get started with your Brain Pattern Mapping.
            </Text>
          </Box>
          <Stack spacing={[3, 4]}>
            <FormControl isRequired id="email">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Email Address
              </FormLabel>
              <Input
                size={["sm", "md"]}
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(event) => handleChange(event, setemail)}
              />
            </FormControl>
            <FormControl isRequired id="password">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Enter Password
              </FormLabel>
              <InputGroup>
                <Input
                  size={["sm", "md"]}
                  type={show ? "text" : "password"}
                  placeholder="Atleast 8 characters long"
                  value={password}
                  onChange={(event) => handleChange(event, setPassword)}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h={["1.5rem", "1.75rem"]}
                    size="sm"
                    onClick={handleClick}
                  >
                    {show ? "Hide" : "Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
          </Stack>

          <Stack spacing={[3, 4]}>
            <Checkbox
              onChange={(event) => handleChange(event, setIsChecked)}
              m={"6px 0 6px 0"}
              letterSpacing={"-0.14px"}
              fontSize={["14px", "15px", "16px"]}
            >
              I agree to the
              <Text as={"b"} color={"black"}>
                {" "}
                Terms{" "}
              </Text>
              and
              <Text as={"b"} color={"black"}>
                {" "}
                Privacy Policy
              </Text>
              .
            </Checkbox>
            <Button
              size={["sm", "md"]}
              isLoading={loading}
              onClick={getLogin}
              bg="black"
              color="white"
              rightIcon={<BsArrowRightShort />}
              mt={["16px", "20px"]}
              _hover={{ bg: "gray" }}
              isDisabled={!email || !password || !isChecked}
              _disabled={{
                bg: "black",
                cursor: "not-allowed",
              }}
            >
              Login to your account
            </Button>
          </Stack>

          <Stack spacing={[3, 4]}>
            <Text fontSize={["14px", "15px", "16px"]}>
              Don't have an account?{" "}
              <Text
                onClick={() => {
                  navigate("/");
                }}
                cursor="pointer"
                as={"span"}
                color={"black"}
                fontWeight="600"
              >
                Sign up here.
              </Text>
            </Text>
          </Stack>

          <Flex spacing={[3, 4]} justifyContent="center">
            <Text
              fontSize={["14px", "15px", "16px"]}
              onClick={() => {
                navigate("/forgot-password");
              }}
              cursor="pointer"
              as={"span"}
              color={"black"}
              _hover={{ color: "gray.500" }}
              width="fit-content"
            >
              Forgot Password ?
            </Text>
          </Flex>
        </Flex>
        {/* Powered By Section positioned just below the card */}
        <Box
          position="absolute"
          top="100%"
          left="50%"
          transform="translate(-50%, 20px)"
          width="100%"
        >
          <Flex alignItems="center" justify="center" gap="12px">
            <Text
              color="black"
              fontSize={["12px", "12px", "12px", "14px", "14px"]}
              mb="5px"
            >
              POWERED BY
            </Text>
            <Image
              src={break_logo_dark}
              alt="Logo"
              width={["120px", "150px", "200px", "200px", "200px"]}
            />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default LoginPage;
